import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";

const categories = [
  { id: "smoked", label: "נתחי פרימיום מהמעשנה", icon: "ri-fire-fill" },
  { id: "grill", label: "גריל ישראלי ואש חיה", icon: "ri-restaurant-fill" },
  { id: "sides", label: "תוספות וסלטים", icon: "ri-leaf-fill" },
];

const menuData: Record<string, {
  name: string;
  time: string;
  wood: string;
  spice: string;
  desc: string;
  img: string;
}[]> = {
  smoked: [
    {
      name: "אסאדו בקר מעושן",
      time: "12 שעות עישון",
      wood: "עץ פקאן",
      spice: "מלח ים, פלפל שחור גס, פפריקה מעושנת",
      desc: "נתח אסאדו שלם שעובר 12 שעות עישון ארוך ומבוקר. מגיע למרקם נימוח במיוחד שבו הבשר נופל מהעצם בעדינות. הציפוי הקרמלי העמוק נוצר מתהליך העישון האיטי.",
      img: "https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/16def423d529232e735e236ca1321405.jpeg",
    },
    {
      name: "בריסקט מעושן",
      time: "16 שעות עישון",
      wood: "עץ אלון",
      spice: "ראב יבש של פלפל שחור, מלח ים ושום כתוש",
      desc: "הבריסקט נפרס לעיני האורחים ישירות מהמעשנה. קרסט שחור מושלם מבחוץ ופנים ורוד ועסיסי. כל פרוסה מגירה נוזלים ומעניקה חוויה בלתי נשכחת.",
      img: "https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/28928580c8d87546d0bace8658b74fdf.jpeg",
    },
    {
      name: "צלעות טלה מעושנות",
      time: "8 שעות עישון",
      wood: "עץ הדר",
      spice: "רוזמרין, שום, לימון ושמן זית",
      desc: "צלעות טלה עדינות בעישון עדין על עצי הדר המעניק להן ארומה פירותית ועמוקה. הבשר רך ועסיסי עם ניחוח מדהים שממלא את האוויר.",
      img: "https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/25c671ab90ae8c2cf89953ae4213bcd4.jpeg",
    },
    {
      name: "אונטריב מעושן",
      time: "14 שעות עישון",
      wood: "עץ אלון ופקאן",
      spice: "ראב יבש מיוחד עם כמון, פפריקה ושום",
      desc: "צלעות בקר ענקיות מעושנות לאיטיות על שילוב של עצי אלון ופקאן. הבשר נופל מהעצם עם כל ביס. מוגש עם רוטב BBQ ביתי.",
      img: "https://static.readdy.ai/image/b0584b9f674fda78ac14eb56b21cd57d/4a3408106de62028958d4479fc1685b3.jpeg",
    },
  ],
  grill: [
    {
      name: "סטייק אנטריקוט מיושן",
      time: "צלייה טרייה",
      wood: "אש חיה",
      spice: "מלח גס, פלפל שחור, חמאת עשבי תיבול",
      desc: "אנטריקוט מיושן 400 גרם הנצרב על להבה גבוהה. צריבה מדויקת שסוגרת את הנתח היטב ושומרת על כל הנוזלים בפנים. מוגש במידת העשייה המדויקת לבקשת האורח.",
      img: "https://public.readdy.ai/ai/img_res/ab3fe05092ed5e4edfe2ed20c427d194.jpg",
    },
    {
      name: "שיפודי נתח קצבים",
      time: "צלייה טרייה",
      wood: "גחלים לוהטות",
      spice: "שמן זית, שום, פטרוזיליה ולימון",
      desc: "נתח קצבים עסיסי חתוך לקוביות ומשורה על שיפוד. נצלה על גחלים לוהטות לקבלת צריבה מושלמת מבחוץ ועסיסיות מלאה מבפנים.",
      img: "https://readdy.ai/api/search-image?query=beef-skewers-butcher-cut-grilled-on-charcoal-fire-charred-exterior-juicy-inside-rustic-dark-background-smoke-rising-authentic-bbq-food-photography-warm-tones&width=600&height=420&seq=gr002&orientation=landscape",
    },
    {
      name: "נקניקיות צ'וריסו בעבודת יד",
      time: "צלייה טרייה",
      wood: "אש חיה",
      spice: "פפריקה ספרדית, שום, יין אדום",
      desc: "נקניקיות צ'וריסו המיוצרות בעבודת יד עם תבלינים ספרדיים אותנטיים. נצלות על אש חיה עד לקבלת עור פריך ומפוצץ. מוגשות עם חרדל דיז'ון איכותי.",
      img: "https://readdy.ai/api/search-image?query=handmade-chorizo-sausages-grilled-on-open-fire-charred-skin-juicy-interior-rustic-wooden-board-dark-background-smoke-authentic-spanish-bbq-food-photography&width=600&height=420&seq=gr003&orientation=landscape",
    },
    {
      name: "טומהוק לשיתוף",
      time: "צלייה טרייה",
      wood: "אש חיה",
      spice: "מלח גס, פלפל שחור, שמן זית",
      desc: "טומהוק סטייק מרשים עם עצם ארוכה, מוגש לשיתוף. נצרב על אש חיה לדרגת מדיום-רייר מושלמת. חוויה ויזואלית מרהיבה שמושכת את כל תשומת הלב.",
      img: "https://readdy.ai/api/search-image?query=massive-tomahawk-steak-long-bone-grilled-on-open-fire-perfect-sear-marks-medium-rare-rustic-dark-wooden-board-dramatic-fire-embers-background-premium-beef-sharing&width=600&height=420&seq=gr004&orientation=landscape",
    },
  ],
  sides: [
    {
      name: "תפוחי אדמה מדורה",
      time: "אפייה טרייה",
      wood: "—",
      spice: "שמן זית, מלח גס, רוזמרין",
      desc: "תפוחי אדמה גדולים אפויים ישירות על הגחלים עם שמן זית ומלח גס. עור פריך ופנים רך ומאודה. מוגשים עם שמנת חמוצה וגבינה מגוררת.",
      img: "https://readdy.ai/api/search-image?query=campfire-baked-potatoes-charred-skin-rustic-wooden-board-olive-oil-sea-salt-rosemary-dark-background-food-photography-warm-tones-comfort-food&width=600&height=420&seq=sd001&orientation=landscape",
    },
    {
      name: "סלטי שוק טריים",
      time: "הכנה טרייה",
      wood: "—",
      spice: "לימון, שמן זית, עשבי תיבול טריים",
      desc: "סלטים טריים עם תיבול לימוני מרענן המאזן את כובד הבשרים. מוכנים סמוך להגשה עם ירקות עונתיים טריים ועשבי תיבול.",
      img: "https://readdy.ai/api/search-image?query=fresh-market-salads-lemon-dressing-herbs-colorful-vegetables-rustic-bowls-dark-wooden-table-food-photography-bright-fresh-mediterranean-style&width=600&height=420&seq=sd002&orientation=landscape",
    },
    {
      name: "צ'ימיצ'ורי ירוק",
      time: "הכנה ביתית",
      wood: "—",
      spice: "פטרוזיליה, שום, חומץ, צ'ילי, שמן זית",
      desc: "רוטב צ'ימיצ'ורי ירוק אותנטי המיוצר במקום. שילוב מושלם של פטרוזיליה טרייה, שום, חומץ וצ'ילי. מלווה כל נתח בשר ומעצים את הטעמים.",
      img: "https://readdy.ai/api/search-image?query=fresh-green-chimichurri-sauce-parsley-garlic-olive-oil-rustic-bowl-dark-wooden-table-food-photography-vibrant-green-herbs-argentinian-bbq-condiment&width=600&height=420&seq=sd003&orientation=landscape",
    },
    {
      name: "איולי שום מעושן",
      time: "הכנה ביתית",
      wood: "—",
      spice: "שום מעושן, מיונז ביתי, לימון",
      desc: "איולי שום מעושן המיוצר במקום עם שום שעבר עישון עדין. קרמי, עשיר ועם עומק טעמים מיוחד. הרוטב המושלם לנקניקיות ולשיפודים.",
      img: "https://readdy.ai/api/search-image?query=smoked-garlic-aioli-creamy-sauce-rustic-bowl-dark-wooden-table-food-photography-warm-tones-homemade-condiment-bbq-dipping-sauce&width=600&height=420&seq=sd004&orientation=landscape",
    },
  ],
};

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState("smoked");

  return (
    <div className="min-h-screen bg-[#faf7f2]" dir="rtl">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-24 pb-16 bg-[#1a0a00] overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://readdy.ai/api/search-image?query=dark-smoky-bbq-texture-background-charcoal-embers-glowing-fire-abstract-dark-moody-atmosphere-smoke-patterns&width=1920&height=400&seq=menuhero&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span
            className="inline-block bg-[#e85d04]/20 text-[#f4a261] border border-[#e85d04]/30 px-4 py-1.5 rounded-full text-sm font-semibold mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            <i className="ri-restaurant-fill ml-1"></i>
            התפריט שלנו
          </span>
          <h1
            className="text-white font-black text-4xl md:text-6xl mb-4 leading-tight"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            בשרים, תוספות
            <br />
            <span className="text-[#e85d04]">וכל מה שביניהם</span>
          </h1>
          <p
            className="text-white/70 text-lg max-w-xl mx-auto"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            כל מנה מוכנה בקפידה עם חומרי גלם פרימיום ותהליכי הכנה ארוכים ואיטיים
          </p>
        </div>
      </section>

      {/* Category Tabs */}
      <section className="sticky top-0 z-40 bg-white border-b border-[#f0e0d0]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex gap-2 py-3 overflow-x-auto">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  activeCategory === cat.id
                    ? "bg-[#e85d04] text-white"
                    : "bg-[#faf7f2] text-[#5a3e2b] hover:bg-[#f0e0d0]"
                }`}
                style={{ fontFamily: "'Assistant', sans-serif" }}
              >
                <i className={cat.icon}></i>
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Menu Items */}
      <section className="py-14">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {menuData[activeCategory].map((item) => (
              <div
                key={item.name}
                className="bg-white rounded-2xl overflow-hidden hover:scale-[1.02] transition-transform duration-300 cursor-pointer group"
              >
                <div className="h-52 overflow-hidden relative">
                  <img
                    src={item.img}
                    alt={item.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 right-3 bg-[#1a0a00]/80 text-[#f4a261] text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1"
                    style={{ fontFamily: "'Assistant', sans-serif" }}>
                    <i className="ri-time-line text-xs"></i>
                    {item.time}
                  </div>
                </div>
                <div className="p-5">
                  <h3
                    className="text-[#1a0a00] font-bold text-lg mb-2"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    {item.name}
                  </h3>
                  <p
                    className="text-[#7a5c44] text-sm leading-relaxed mb-4"
                    style={{ fontFamily: "'Assistant', sans-serif" }}
                  >
                    {item.desc}
                  </p>
                  {item.wood !== "—" && (
                    <div className="flex flex-col gap-1.5 border-t border-[#f0e0d0] pt-3">
                      <div className="flex items-start gap-2">
                        <span className="text-[#e85d04] text-xs font-bold whitespace-nowrap" style={{ fontFamily: "'Assistant', sans-serif" }}>עץ עישון:</span>
                        <span className="text-[#9a7060] text-xs" style={{ fontFamily: "'Assistant', sans-serif" }}>{item.wood}</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <span className="text-[#e85d04] text-xs font-bold whitespace-nowrap" style={{ fontFamily: "'Assistant', sans-serif" }}>תיבול:</span>
                        <span className="text-[#9a7060] text-xs" style={{ fontFamily: "'Assistant', sans-serif" }}>{item.spice}</span>
                      </div>
                    </div>
                  )}
                  {item.wood === "—" && (
                    <div className="border-t border-[#f0e0d0] pt-3">
                      <div className="flex items-start gap-2">
                        <span className="text-[#e85d04] text-xs font-bold whitespace-nowrap" style={{ fontFamily: "'Assistant', sans-serif" }}>תיבול:</span>
                        <span className="text-[#9a7060] text-xs" style={{ fontFamily: "'Assistant', sans-serif" }}>{item.spice}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#1a0a00]">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2
            className="text-white font-black text-3xl md:text-4xl mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            בואו נתכנן את
            <br />
            <span className="text-[#e85d04]">אירוע הבשרים שלכם</span>
          </h2>
          <p
            className="text-white/60 text-lg mb-8"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            נבנה יחד תפריט מותאם אישית לאירוע שלכם
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              onClick={() => setTimeout(() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" }), 100)}
              className="inline-block bg-[#e85d04] hover:bg-[#d44d00] text-white px-10 py-4 rounded-full text-base font-bold transition-colors duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              בואו נתכנן את האירוע ←
            </Link>
            <a
              href="https://wa.me/972542465614"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 border-2 border-[#25d366] text-[#25d366] hover:bg-[#25d366] hover:text-white px-10 py-4 rounded-full text-base font-bold transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              <i className="ri-whatsapp-fill"></i>
              שלחו הודעה בוואטסאפ
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Menu;
